import React from "react";
import { Button, TextField, Tooltip, Grid } from "@mui/material";
import { FileCopy } from "@mui/icons-material";
import { useSnackbar } from "components/haven-design/snackbar";

type Props = {
  text: string;
}

const Copyable: React.FC<Props> = ({ text }) => {
  const copy = React.useRef<HTMLInputElement>(null);
  const { openSnackbar } = useSnackbar();
  const copyText = async () => {
    if (copy) {
      copy.current?.select();
    }

    await navigator.clipboard.writeText(text);
    openSnackbar({ message: "Copied!", status: "success" });
  };

  return (
    <Grid container>
      <Grid size={{ xs: 9 }}>
        <Tooltip title="Click to copy">
          <TextField
            size="small"
            inputRef={copy}
            value={text}
            onClick={copyText}
            fullWidth />
        </Tooltip>
      </Grid>
      <Grid size={{ xs: 3 }}>
        <Button
          style={{ marginLeft: 16, marginTop: 2 }}
          color="secondary"
          onClick={copyText}
          variant="outlined"
          startIcon={<FileCopy />}
        >
          Copy
        </Button>
      </Grid>
    </Grid>
  );
};

export default Copyable;
